import { IUserInfo } from "../types/appDataTypes"
import apiMiddleware from "./api"
import { dispatch } from "../store"
import { appActions } from "../actions"

export const retrieveDocuments = (userInfo: IUserInfo) => {
    if (!(userInfo && userInfo.artEntry && userInfo.artEntry.length)) return
    for (let entry of userInfo.artEntry) {
        if (entry.entryId) apiMiddleware.getEntryDocuments(userInfo.appId, entry.entryId).then((response) => {
            const { data = { p1: null, s1: null, s2: null } } = response
            dispatch(appActions.updateEntryDocuments(entry.entryId, data))
        })
    }
}